export function integer(props, propName, componentName) {
  const propValue = props[propName];

  if (!propValue) return;
  return integerRequired(props, propName, componentName);
}

export function integerRequired(props, propName, componentName) {
  const propValue = props[propName];
  const isInteger = Number.isInteger(propValue);
  const isStringInteger = parseInt(propValue).toString() === propValue;

  if (!isInteger && !isStringInteger) {
    return new Error(
      `Invalid prop ${propName} supplied to ${componentName}. Expected integer or string integer. Validation failed.`
    );
  }
}
